module.exports = __webpack_public_path__ + "img/cy_03.png";